module.exports = {
  title: 'Treasurenet',

  /**
   * System layout configuration
   */
  showSettings: false,

  /**
   * Show tagsView
   */
  tagsView: false,

  /**
   * Is the head fixed
   */
  fixedHeader: true,

  /**
   * Show logo
   */
  sidebarLogo: true,

  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
}
